import { render, staticRenderFns } from "./SectionChart.vue?vue&type=template&id=654e2e33&"
import script from "./SectionChart.vue?vue&type=script&lang=js&"
export * from "./SectionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports